import React from 'react'
import Applelogo from "../../assets/images/Apple.webp";
import googlelogo from "../../assets/images/Google.webp";
const PlayStoreIcons = ({ className, appleHref, appleLogo, playstoreHref, playStoreLogo }) => {
    return (
        <div className={className}>

            <div className="apple-logo-box neapplelogo flex gap-4 mb-0 ">
                <a
                    href={appleHref || "https://apps.apple.com/us/app/solidarity-drive/id6738992231"}
                    target="_blank"
                    rel="noopener noreferrer"
                // onClick={() =>
                //   trackGAEvent("Download App", "Click", "Apple Store")
                // }
                >
                    <img
                        className=" w-[195px] h-[60px]"
                        src={appleLogo || Applelogo}
                        alt="Apple logo"
                    />
                </a>
                <a
                    href={playstoreHref || "https://play.google.com/store/apps/details?id=bh.co.discovery.vitality.drive.international.solidarity"}
                    target="_blank"
                    rel="noopener noreferrer"
                // onClick={() =>
                //   trackGAEvent("Download App", "Click", "Google Play")
                // }
                >
                    <img
                        className=" w-[195px] h-[60px]"
                        src={playStoreLogo || googlelogo}
                        alt="Google logo"
                    />
                </a>
            </div>
        </div>
    )
}

export default PlayStoreIcons